<template>
  <v-container id="uploadCenter">
    <v-card class="pa-4 pt-0">
      <v-row v-if="plItem">
        <v-col cols="10" xs="12">
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-flex xs12>
                    <v-checkbox outlined v-model="plItem.active" class="mx-2" label="Aktiv"></v-checkbox>
                  </v-flex>

                </v-col>
                <v-col cols="6" class="py-0">
                  <v-flex xs12>
                    Aktiv von
                    <v-datetime-picker @input="setDT" v-model="formattedDatetime" date-format="dd.MM.yyyy" timeFormat="HH:mm"></v-datetime-picker>
                  </v-flex>

                </v-col>
                <v-col cols="6" class="py-0">
                  <v-flex xs12>
                    Aktiv bis
                    <!--<v-text-field v-model="formattedDatetimeTill"></v-text-field>-->
                    <v-datetime-picker @input="setDT" v-model="formattedDatetimeTill" date-format="dd.MM.yyyy" timeFormat="HH:mm">
                    </v-datetime-picker>
                  </v-flex>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                  :label="'Name (' + plItem.type + ')'"
                  clearable
                  outlined
                  v-model="plItem.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0" v-if="false">
                  <v-text-field
                  label="Sortierungsindex"
                  clearable
                  outlined
                  v-model="plItem.orderNr"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                          label="Spielzeit in Sekunden"
                          clearable
                          outlined
                          v-model="plItem.duration"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              {{plItem.type}}
              <v-col cols="12" class="pa-4" v-if="plItem.type === 'IMAGE'">
                Bild
                <v-img :src="getImageUrl(plItem)"></v-img>
              </v-col>
              <v-col cols="12" class="pa-4" v-if="plItem.type === 'WEB'">
                Bild
                <v-img :src="tableUtils.getImage(plItem)"></v-img>
                <span class="">{{plItem.localFileName}}</span>
              </v-col>
              <v-col cols="12" class="pa-4" v-if="plItem.type === 'VIDEO'">
                Video
                <span class="quer">
                  <video :src="getVideoUrl(plItem)" ref="player" autoplay controls></video>
                </span>
              </v-col>

            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2" xs="12" style="text-align: right" v-if="!isDialog">
          <v-btn @click="close" icon color="red">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12" v-if="progress != 100" class="pa-4">
          <v-progress-linear
          color="light-blue"
          height="10"
          :value="progress"
          striped
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-row v-if="!isDialog">
        <v-col cols="6" class="py-0">
          <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
        </v-col>
        <v-col cols="6" class="py-0 text-right">
          <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
          </v-btn>
        </v-col>


      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'

var moment = require('moment');
export default {
  name: 'PlaylistItemDefault.vue',
  components: {},
  props: ['propItem'],
  data () {
    return {
      items: [],
      plItem: {
        name: ''
      },
      isDialog: false,
      date: '' + new Date(),
      player: null,
      guid: '-1',
      progress: 100,
      activeFrom: new Date().getTime(),
      activeTill: new Date().getTime(),
      formattedDatetime: '01.09.2019 12:00',
      formattedDatetimeTill: '01.09.2019 13:00',
      textFieldProps: {
        appendIcon: 'event'
      },
      dateProps: {
        headerColor: 'red'
      },
      tableUtils: require('./../../tables/TableUtils').default,
      timeProps: {
        useSeconds: true,
        ampmInTitle: true
      },
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      }
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('playlist', data)
      this.plItem = data
      if (this.$refs.player) {
        this.player = this.$refs.player.dp
      }

      if (data.activeFrom === null || data.activeFrom === 0 ) {
        data.activeFrom = new Date().getTime()
      }
      if (data.activeTill === null || data.activeTill === 0 ) {
        var d = new Date()
        d.setFullYear(d.getFullYear() + 1)
        data.activeTill = d.getTime()
      }
      this.activeFrom = new Date(data.activeFrom)
      this.activeTill = new Date(data.activeTill)

      this.formattedDatetime = moment(this.activeFrom).format("DD.MM.YYYY HH:mm")
      this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY HH:mm")
    },
    onGetItems: function (data) {
      console.log('onGetItems', data)
      this.items = data
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      this.progress = percent
    },
    onUploadSuccess (data) {
      console.log('upload done', data)
      this.$refs.table.reload(this.guid)
    },
    getImageUrl (item) {
      console.log('getImageUrl', item)
      var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + item.localFileName
      return url
    },
    getWebURL (item) {
      console.log('getWebURL', item)
      var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + item.localFileName
      return url
    },
    getVideoOptions (item) {
      var options = {
        video: {
          url: this.getVideoUrl(item),
          pic: 'http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg'
        },
        autoplay: true
      }
      return options
    },
    getVideoUrl (item) {
      return Vue.prototype.$api.getVideoUrl(item)
    },
    onItemUpdated (data) {
      console.log('onItemUpdated', data)
    },
    close: function () {
      window.history.back();
    },
    cancelItem: function () {
      this.$router.push('/Playlist/' + this.plItem.guidPlaylist)
    },
    updateItem: function () {
      // debugger
      // .format("DD.MM.YYYY HH:mm")


      this.formattedDatetime = moment(this.formattedDatetime, "DD.MM.YYYY HH:mm").toDate()
      this.formattedDatetimeTill = moment(this.formattedDatetimeTill, "DD.MM.YYYY HH:mm").toDate()
      this.plItem.activeFrom = this.formattedDatetime.getTime()
      this.plItem.activeTill = this.formattedDatetimeTill.getTime()

      this.formattedDatetime = moment(this.plItem.activeFrom).format("DD.MM.YYYY HH:mm")
      this.formattedDatetimeTill = moment(this.plItem.activeTill).format("DD.MM.YYYY HH:mm")

      Vue.prototype.$api.updatePlayListItem(this.plItem.guid, this.plItem, this.onItemUpdated)
    },
    play () {
      console.log('play callback')
    },
    switchHandle () {
      /*
      this.player.switchVideo({
        url: 'http://static.smartisanos.cn/common/video/video-jgpro.mp4'
      })
       */
    },
    setDT (a) {
      var d = new Date(a)
      console.log(d.getTime())
    }
  },
  mounted () {
    this.guid = this.$route.params.guid
    if (this.propItem) {
      this.guid = this.propItem.guid
      this.isDialog = true
    }
    console.log('m', this.guid)
    Vue.prototype.$api.loadPlayListItem(this.guid, this.onGetData)
  }
}
</script>

<style scoped>

</style>
